import SubscriptionBase from "@/views/subscriptions/index.vue";
import SubscriptionsGetStarted from "@/views/subscriptions/subscriptionsGetStarted/index.vue";
import MenuConfiguration from "@/views/subscriptions/menuConfiguration/index.vue";
import SubscriptionsOrderProducts from "@/views/subscriptions/subscriptionsOrderProducts/index.vue";
import SubscriptionIngredients from "@/views/subscriptionsClient/subscriptionIngredients/index.vue";
import subscriptionsDashboard from "@/views/subscriptionsClient/subscriptionsDashboard/index.vue";
import SubscriptionHistory from "@/views/subscriptionsClient/subscriptionsHistory/index.vue";
import userWithoutSubscription from "@/views/userWithoutSubscription/index.vue";
import registerNewUser from "@/views/registerNewUser/index.vue";

// Subscriptions Dashboard
import EditSubscription from "@/views/subscriptions/EditSubscription/index.vue";
import SubscriptionOrders from "@/views/subscriptions/SubscriptionOrders/index.vue";
import SubscriptionOrdersHome from "@/views/subscriptions/SubscriptionOrders/SubscriptionOrdersHome/SubscriptionOrdersHome.vue";
import SubscriptionOrderDetail from "@/views/subscriptions/SubscriptionOrders/SubscriptionOrderDetail/SubscriptionOrderDetail.vue";
import OrdersHistory from "@/views/subscriptions/OrdersHistory/index.vue";
import OrdersHistoryTable from "@/views/subscriptions/OrdersHistory/OrdersHistoryTable/OrdersHistoryTable.vue";

// Subscriptions OnBoarding
import OnBoarding from "@/views/subscriptions/OnBoarding/index.vue";

// Missing subscription
import MissingSubscription from "@/views/subscriptions/MissingSubscription/index.vue";

// Chef Suggestions
import ChefSuggestions from "@/views/subscriptions/ChefSuggestions/index.vue";

import { isSubscription, hasToken, missingSubscription, canEditNextOrder } from "./guard.ts";

export default [
  {
    path: "/mi-menu/comenzar",
    name: "subscriptionWelcome",
    component: SubscriptionsGetStarted,
  },
  {
    path: "/mi-menu",
    name: "subscription",
    component: SubscriptionBase,
    redirect: { name: "subscriptionDashboard" },
    beforeEnter: hasToken,
    children: [
      {
        path: "/mi-menu/welcome",
        redirect: { name: "subscriptionOnBoarding" },
      },
      {
        path: "/mi-menu/cambiar-producto/menu/:menu_id/dia/opcion-de-menu/:menu_option_id/dia/:count_id/item-de-menu/:menu_item_id",
        name: "changeProduct",
        component: SubscriptionIngredients,
        beforeEnter: isSubscription,
        redirect: { name: "subscriptionDashboard" },
      },
      {
        path: "/mi-menu/cambiar-plato/menu/:menu_id/dia/:count_id",
        name: "chefSuggestions",
        component: ChefSuggestions,
        beforeEnter: isSubscription,
        redirect: { name: "subscriptionDashboard" },
      },
      {
        path: "/mi-menu/mi-plan/menu/:menu_id/dia/:count_id",
        name: "openWeek_menuConfiguration",
        component: MenuConfiguration,
      },

      {
        path: "/mi-menu/orden/:order_id",
        name: "subscriptions_order",
        component: SubscriptionsOrderProducts,
      },
      {
        path: "/mi-menu/mi-historial",
        name: "subscriptions_history",
        component: SubscriptionHistory,
      },
      {
        path: "/mi-menu/nuevo-usuario",
        name: "userWithoutSubscription",
        component: userWithoutSubscription,
      },
      {
        path: "/mi-menu/mi-dashboard",
        redirect: { path: "/mi-menu/mis-pedidos" },
      },
      {
        path: "/mi-menu/registro",
        name: "register",
        component: registerNewUser,
      },
      {
        path: "/mi-menu/on-boarding",
        name: "subscriptionOnBoarding",
        beforeEnter: isSubscription,
        component: OnBoarding,
      },
      {
        path: "/mi-menu/sin-suscripcion",
        name: "missingSubscription",
        beforeEnter: missingSubscription,
        component: MissingSubscription,
      },
    ],
  },
  {
    path: "/mi-menu",
    name: "subscriptionDashboard",
    redirect: { name: "subscriptionOrders" },
    component: subscriptionsDashboard,
    beforeEnter: hasToken,
    children: [
      {
        path: "mis-pedidos",
        name: "subscriptionOrders",
        beforeEnter: isSubscription,
        component: SubscriptionOrders,
        redirect: { name: "subscriptionOrdersHome" },
        children: [
          {
            path: "inicio",
            name: "subscriptionOrdersHome",
            component: SubscriptionOrdersHome,
          },
          {
            path: "pedido-actual",
            name: "subscriptionLastOrderDetail",
            component: SubscriptionOrderDetail,
          },
          {
            path: "proximo-pedido",
            name: "subscriptionNextOrderDetail",
            component: SubscriptionOrderDetail,
            beforeEnter: canEditNextOrder,
          },
        ],
      },
      {
        path: "mi-suscripcion",
        name: "subscriptionSettings",
        beforeEnter: isSubscription,
        component: EditSubscription,
      },
      {
        path: "historial",
        name: "ordersHistory",
        beforeEnter: isSubscription,
        component: OrdersHistory,
        redirect: { name: "ordersHistoryTable" },
        children: [
          {
            path: "pedidos",
            name: "ordersHistoryTable",
            component: OrdersHistoryTable,
          },
          {
            path: "pedidos/:orderId",
            name: "ordersHistoryDetail",
            component: SubscriptionOrderDetail,
          },
        ],
      },
    ],
  },
];
